// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__aKmEE","bigColWidth":"Table_bigColWidth__1lSx5","biggerColWidth":"Table_biggerColWidth__3_PPk","row":"Table_row__2Go9Y","col":"Table_col__2jaze"};